import React from 'react'
import Img from 'gatsby-image'
import MediaQuery from 'react-responsive'
import { URLS } from '../../../constants/routes'

// Import styled components
import {
  Wrapper,
  StatitisColWrapper,
  StatitisWrapper
} from './StatitisResponsive'

// Import common components
import { FlexBox } from '../../common/Box'
import StatitisItem from './StatitisItem'
import StatitisMore from './StatitisMore'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'

// List of statitis
const statitisList = [
  {
    icon: 'engineers',
    title: 'Engineers',
    text: '21+',
    className: 'statitis engineers',
    subStatitis: 'first'
  },
  {
    icon: 'designers',
    title: 'Designers',
    text: '8+',
    className: 'statitis designers',
    subStatitis: 'second'
  },
  {
    icon: 'game',
    title: 'Games Build',
    text: '20+',
    className: 'statitis game',
    subStatitis: 'third'
  },
  {
    icon: 'languages',
    title: 'Languages',
    text: '7+',
    className: 'statitis languages',
    subStatitis: 'first'
  },
  {
    icon: 'download',
    title: 'Downloads',
    text: '1M+',
    className: 'statitis download',
    subStatitis: 'second'
  },
  {
    type: 'about-us',
    href: URLS.ABOUT_US,
    text: 'Learn More About Us',
    subStatitis: 'third'
  }
]

const renderCol = (data) => {
  return (
    <Wrapper>
      <FlexBox flexDirection='column'>
        {
          data.map((item, index) => {
            return (
              item.href ?
                <StatitisMore
                  key={index}
                  href={item.href}
                  text={item.text}
                /> :
                <StatitisItem
                  key={index}
                  icon={item.icon}
                  title={item.title}
                  text={item.text}
                  className={item.className}
                  customStyle={{
                    backgroundColor: COLORS.gray,
                    margin: `${px2Rem(2.5)} 0`,
                    height: px2Rem(220),
                    opacity: 0
                  }}
                />
            )
          }
          )
        }
      </FlexBox>
    </Wrapper>
  )
}

const renderImageCol = (aboutUsDesign, aboutUsGame) => (
  <Wrapper>
    <FlexBox flexDirection='column'>
      <Img
        outerWrapperClassName='statitis-image'
        sizes={aboutUsGame.sizes}
        style={{ height: '100%' }}
      />
      <Img
        outerWrapperClassName='statitis-image'
        sizes={aboutUsDesign.sizes}
        style={{ height: '100%' }}
      />
    </FlexBox>
  </Wrapper>
)

// render static on mobile
const renderStatitisMobile = () => (
  <FlexBox
    flexWrap='wrap'
    customStyle={{
      backgroundColor: COLORS.gray,
      marginBottom: px2Rem(30)
    }}
  >
    {statitisList && statitisList.map((item, index) => {
      return (
        <StatitisWrapper key={index}>
          {item.href ?
            <StatitisMore href={item.href} text={item.text} /> :
            <StatitisItem
              icon={item.icon}
              title={item.title}
              text={item.text}
              className={item.className}
              customStyle={{
                height: px2Rem(120),
                opacity: 0,
                backgroundColor: COLORS.white
              }}
            />
          }
        </StatitisWrapper>
      )
    })}
  </FlexBox>
)

const Statitis = ({ aboutUsDesign, aboutUsGame }) => (
  <MediaQuery maxWidth={767}>
    {(matches) => {
      if (matches) {
        return (
          renderStatitisMobile()
        )
      }
      return (
        <StatitisColWrapper>
          {renderImageCol(aboutUsDesign, aboutUsGame)}
          {renderCol(statitisList.filter(statitis => (statitis.subStatitis === 'first')))}
          {renderCol(statitisList.filter(statitis => (statitis.subStatitis === 'second')))}
          {renderCol(statitisList.filter(statitis => (statitis.subStatitis === 'third')))}
        </StatitisColWrapper>
      )

    }}
  </MediaQuery>
)

export default Statitis



// WEBPACK FOOTER //
// ./src/components/sections/statitis/Statitis.js